import NavigationService from 'services/navigation/NavigationService';
import React from 'react';
import { Route as DOMRoute, Redirect, useLocation } from 'react-router-dom';
import { ROUTES } from 'router/routes';
import { getValidPath } from 'helpers/path';
import { useSelector } from 'react-redux';
import AuthService from 'services/auth/AuthService';
import { authStatuses } from 'constants/auth';

export default function CustomRoute({
  isProtected = false,
  roles = [],
  isRedirect = true,
  ...routeProps
}) {
  const location = useLocation();

  const authStatus = useSelector((state) => state?.auth?.status);
  const isAuthorized = authStatus === authStatuses.authorized;
  const isTempPassword =
    useSelector((state) => state?.auth?.isTempPassword) ?? false;
  const userRoles = useSelector((state) => state?.auth?.user?.roles) ?? [];

  const isRestored = authStatus !== authStatuses.unknown;

  const isAccessRoute = AuthService.hasAccessToRoute({
    userRoles,
    routeRoles: roles,
  });

  const isTempPasswordRoute =
    getValidPath(location.pathname) ===
    getValidPath(ROUTES.changeTempPassword.path);

  if (!isRestored) {
    return null;
  }

  if (isRedirect) {
    if (!isAuthorized && isProtected) {
      return <Redirect to={getValidPath(ROUTES.signIn.path)} />;
    }

    if (isAuthorized && isTempPassword && !isTempPasswordRoute) {
      return <Redirect to={getValidPath(ROUTES.changeTempPassword.path)} />;
    }

    if (!isAccessRoute && isAuthorized) {
      const defaultPath = NavigationService.getDefaultPath();
      return <Redirect to={getValidPath(defaultPath)} />;
    }
  }
  return <DOMRoute {...routeProps} />;
}
